export * from './aside.directive';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/directives/aside/index.ts